<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-900 px-4">
    <div class="w-full max-w-sm p-6 bg-gray-800 rounded-lg shadow-lg space-y-6">
      <h2 class="text-2xl font-bold text-center text-white">Enter 2FA Code</h2>

      <div class="flex justify-between space-x-2">
        <input
            v-for="(digit, index) in pin"
            :key="index"
            ref="pinInput"
            type="text"
            maxlength="1"
            class="w-12 h-12 text-center text-2xl rounded bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            v-model="pin[index]"
            @input="onInput(index)"
            @keydown.backspace.prevent="onBackspace(index)"
        />
      </div>

      <div class="text-center">
        <button
            @click="submitCode"
            class="w-full py-2 px-4 bg-blue-600 text-white font-semibold rounded hover:bg-blue-700"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/EventBus";

export default {
  name: 'TfVerify',
  props: {},
  data() {
    return {
      pin: Array(6).fill(''),
    };
  },
  methods: {
    onInput(index) {
      const input = this.pin[index];
      if (!/^\d$/.test(input)) {
        this.pin[index] = '';
        return;
      }

      // Move to next input
      if (index < 5) {
        this.$refs.pinInput[index + 1].focus();
      }

      // Auto-submit if full
      if (this.pin.join('').length === 6 && this.pin.every(p => p !== '')) {
        this.submitCode();
      }
    },
    onBackspace(index) {
      if (this.pin[index] !== '') {
        this.pin[index] = '';
        return;
      }
      if (index > 0) {
        this.$refs.pinInput[index - 1].focus();
        this.pin[index - 1] = '';
      }
    },
    submitCode() {
      const code = this.pin.join('');
      if (code.length !== 6) {
        alert('Please enter the full 6-digit code.');
        return;
      }
      EventBus.emit('verify2FA', {
        code: code,
      });
    },
  },
};
</script>
